import { createProjectDataStore } from '@/stores/createProjectDataStore';
import { hasAccess } from '@/stores/createResourcePermissionStore';
import { Features, isSwitchOn } from '@/stores/createSwitchStore';
import http from 'common-module/src/util/http';
import {
  useCurrentProjectPermissionResourceStore,
  useCurrentProjectRoleResourceStore
} from '@/stores/useResourcePermissionStore';
import { useGetter } from 'common-module/src/util/useVuex';

export const useProjectRoleStore = createProjectDataStore('project/role', {
  hasRole: (data, roleCodes?: string[], every?: boolean) => {
    return hasAccess(data, roleCodes, every);
  }
}, {
  default: ['']
});

export const useProjectPermissionStore = createProjectDataStore('project/permission', {
  hasPermission: (data, permissionCodes?: string[], every?: boolean) => {
    return hasAccess(data, permissionCodes, every);
  }
}, {
  default: ['']
});

export const useProjectSwitchStore = createProjectDataStore('project/switch', {
  isSwitchOn: (data: Features, switchCodes?: string[], every?: boolean) => {
    return isSwitchOn((name) => data[name], switchCodes, every);
  }
});

let loadAllProjectPermissionPromise: Promise<void> | null = null;
/**
 * 加载所有项目的权限，单例模式（同时只有一个在加载）
 * 默认不会刷新数据，除非传入refresh true
 * @param payload
 */
export const loadAllProjectPermission = (payload?: {
  refresh: boolean
}) => {
  if (loadAllProjectPermissionPromise) {
    return loadAllProjectPermissionPromise;
  }
  const store = useProjectPermissionStore();
  const roles = useProjectRoleStore();
  if (store.hasValue() && roles.hasValue() && !payload?.refresh) {
    return Promise.resolve();
  }

  const currentProjectPermissionStore = useCurrentProjectPermissionResourceStore();
  const currentProjectRoleStore = useCurrentProjectRoleResourceStore();

  const currentProject = useGetter('app/currentProject');

  // eslint-disable-next-line no-async-promise-executor
  loadAllProjectPermissionPromise = new Promise(async (resolve) => {
    const allProjectPermission: {
      projectId: number,
      permCodes: string[],
      roleCodes: string[]
    }[] = await http.post('/project/user-project-perms', { queryAll: true }, { showError: false });
    store.setAll(allProjectPermission.reduce((acc, cur) => {
      acc[cur.projectId] = cur.permCodes;
      return acc;
    }, {} as Record<number, string[]>));

    roles.setAll(allProjectPermission.reduce((acc, cur) => {
      acc[cur.projectId] = cur.roleCodes;
      return acc;
    }, {} as Record<number, string[]>));

    if (currentProject) {
      const projectResources = allProjectPermission.find(item => item.projectId === currentProject.id);
      if (projectResources) {
        currentProjectPermissionStore.setResources(projectResources.permCodes);
        currentProjectRoleStore.setResources(projectResources.roleCodes);
      }
    }
    resolve();
    loadAllProjectPermissionPromise = null;
  });
  return loadAllProjectPermissionPromise;
};
